// import React, { CSSProperties } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { MdPrivacyTip, MdEmail } from 'react-icons/md';
// import { IoArrowBack } from 'react-icons/io5';

// const PrivacyPolicy: React.FC = () => {
//   const navigate = useNavigate();

//   const openEmail = () => {
//     window.location.href = "mailto:support@instaship.co.in";
//   };

//   const sections = [
//     {
//       title: '1. Introduction',
//       content: [
//         'Welcome to Instaship Logistics Private Limited ("Company," "we," "us," or "our"). This Privacy Policy explains how our company collects, uses, and protects your personal data when you use our services.',
//       ],
//     },
//     {
//       title: '2. Data Collection',
//       bullets: [
//         'Personal details: Name, mobile number, email, GST details',
//         'Payment information and transaction history',
//         'Location data for tracking and operational purposes',
//       ],
//     },
//     {
//       title: '3. Use of Data',
//       bullets: [
//         'Provide transportation services and manage bookings',
//         'Send order updates and promotional offers',
//         'Comply with legal and tax obligations',
//       ],
//     },
//     {
//       title: '4. Data Sharing',
//       bullets: [
//         'Share with transport partners for service fulfillment',
//         'Never sell or rent user data to third parties',
//         'Share with government authorities when legally required',
//       ],
//     },
//     {
//       title: '5. Security',
//       bullets: [
//         'Implement strict security measures for data protection',
//         'Users responsible for securing login credentials',
//       ],
//     },
//     {
//       title: '6. Data Retention',
//       bullets: [
//         'Retain data as needed for operations and legal compliance',
//         'Data deletion requests subject to legal limitations',
//       ],
//     },
//     {
//       title: '7. Cookies and Tracking',
//       bullets: [
//         'Use cookies to enhance user experience',
//         'Manage preferences through browser settings',
//       ],
//     },
//     {
//       title: '8. Your Rights',
//       bullets: [
//         'Access, modify, or delete personal data',
//         'Submit data requests via support email',
//       ],
//     },
//     {
//       title: '9. Changes to Policy',
//       bullets: [
//         'Notify users via email or app updates',
//       ],
//       note: 'By using our platform, you acknowledge reading and understanding this Privacy Policy.',
//     },
//   ];

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <button onClick={() => navigate(-1)} style={styles.backButton}>
//           <IoArrowBack size={24} color="#4169E1" />
//         </button>
//         <h1 style={styles.headerTitle}>Privacy Policy</h1>
//       </div>

//       <div style={styles.updatedRow}>
//         <MdPrivacyTip size={28} color="#4169E1" />
//         <span style={styles.lastUpdated}>Last Updated: June 10, 2025</span>
//       </div>

//       <div style={styles.sections}>
//         {sections.map((section, idx) => (
//           <div key={idx} style={styles.sectionCard}>
//             <h2 style={styles.sectionTitle}>{section.title}</h2>
//             {section.content && section.content.map((para, i) => (
//               <p key={i} style={styles.sectionText}>{para}</p>
//             ))}
//             {section.bullets && section.bullets.map((bullet, j) => (
//               <div key={j} style={styles.bulletPoint}>
//                 <div style={styles.bulletDot} />
//                 <p style={styles.sectionText}>{bullet}</p>
//               </div>
//             ))}
//             {section.note && <p style={styles.note}>{section.note}</p>}
//           </div>
//         ))}

//         <div style={styles.contactCard} onClick={openEmail}>
//           <MdEmail size={22} color="#4169E1" />
//           <span style={styles.contactText}>Contact: support@instaship.co.in</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// const styles: Record<string, CSSProperties> = {
//   container: {
//     maxWidth: '800px',
//     margin: '0 auto',
//     padding: '2.5rem 1.5rem',
//     fontFamily: "'Inter', sans-serif",
//     backgroundColor: '#f9fafb',
//     color: '#333',
//   },
//   header: {
//     display: 'flex',
//     alignItems: 'center',
//     marginBottom: '1.5rem',
//   },
//   backButton: {
//     marginRight: '1rem',
//     background: 'none',
//     border: 'none',
//     cursor: 'pointer',
//   },
//   headerTitle: {
//     fontSize: '1.75rem',
//     fontWeight: 700,
//     color: '#4169E1',
//   },
//   updatedRow: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     marginBottom: '2rem',
//   },
//   lastUpdated: {
//     fontSize: '0.875rem',
//     color: '#666',
//   },
//   sections: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '2rem',
//   },
//   sectionCard: {},
//   sectionTitle: {
//     fontSize: '1.25rem',
//     fontWeight: 600,
//     marginBottom: '0.75rem',
//   },
//   sectionText: {
//     fontSize: '1rem',
//     lineHeight: 1.6,
//     marginBottom: '0.75rem',
//   },
//   bulletPoint: {
//     display: 'flex',
//     alignItems: 'flex-start',
//     gap: '0.5rem',
//     marginBottom: '0.5rem',
//   },
//   bulletDot: {
//     width: 6,
//     height: 6,
//     borderRadius: '50%',
//     backgroundColor: '#4169E1',
//     marginTop: 8,
//     flexShrink: 0,
//   },
//   note: {
//     marginTop: '0.75rem',
//     fontStyle: 'italic',
//     color: '#555',
//   },
//   contactCard: {
//     marginTop: '2rem',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     padding: '1rem',
//     backgroundColor: '#e6f0ff',
//     borderRadius: '8px',
//     border: '1px solid #b3d1ff',
//     cursor: 'pointer',
//   },
//   contactText: {
//     fontSize: '1rem',
//     fontWeight: 500,
//     color: '#4169E1',
//   },
// };

// export default PrivacyPolicy;


















// import React, { CSSProperties } from 'react';
// import { MdPrivacyTip } from 'react-icons/md';

// const PrivacyPolicy: React.FC = () => {
//   const sections = [
//     {
//       title: '1. Introduction',
//       bullets: [
//         'Welcome to Instaship Logistics Private Limited ("Company," "we," "us," or "our"). This Privacy Policy explains how our company collects, uses, and protects your personal data when you use our services.',
//       ],
//     },
//     {
//       title: '2. Data Collection',
//       bullets: [
//         'Personal details: Name, mobile number, email, GST details',
//         'Payment information and transaction history',
//         'Location data for tracking and operational purposes',
//       ],
//     },
//     {
//       title: '3. Use of Data',
//       bullets: [
//         'Provide transportation services and manage bookings',
//         'Send order updates and promotional offers',
//         'Comply with legal and tax obligations',
//       ],
//     },
//     {
//       title: '4. Data Sharing',
//       bullets: [
//         'Share with transport partners for service fulfillment',
//         'Never sell or rent user data to third parties',
//         'Share with government authorities when legally required',
//       ],
//     },
//     {
//       title: '5. Security',
//       bullets: [
//         'Implement strict security measures for data protection',
//         'Users responsible for securing login credentials',
//       ],
//     },
//     {
//       title: '6. Data Retention',
//       bullets: [
//         'Retain data as needed for operations and legal compliance',
//         'Data deletion requests subject to legal limitations',
//       ],
//     },
//     {
//       title: '7. Cookies and Tracking',
//       bullets: [
//         'Use cookies to enhance user experience',
//         'Manage preferences through browser settings',
//       ],
//     },
//     {
//       title: '8. Your Rights',
//       bullets: [
//         'Access, modify, or delete personal data',
//         'Submit data requests via support email',
//       ],
//     },
//     {
//       title: '9. Changes to Policy',
//       bullets: ['Notify users via email or app updates'],
//       note: 'By using our platform, you acknowledge reading and understanding this Privacy Policy.',
//     },
//   ];

//   return (
//     <div style={styles.container}>
//       {/* Header */}
//       <div style={styles.header}>
//         <MdPrivacyTip style={styles.headerIcon} />
//         <div>
//           <h1 style={styles.title}>Privacy Policy</h1>
//           <p style={styles.lastUpdated}>Last Updated: June 10, 2025</p>
//         </div>
//       </div>

//       {/* Divider */}
//       <hr style={styles.divider} />

//       {/* Sections */}
//       <div style={styles.sections}>
//         {sections.map((section) => (
//           <div key={section.title} style={styles.card}>
//             <h2 style={styles.sectionTitle}>{section.title}</h2>
//             <ul style={styles.bulletList}>
//               {section.bullets.map((bullet, index) => (
//                 <li key={index} style={styles.bullet}>{bullet}</li>
//               ))}
//             </ul>
//             {section.note && <p style={styles.note}>{section.note}</p>}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// const styles: Record<string, CSSProperties> = {
//   container: {
//     maxWidth: '960px',
//     margin: '0 auto',
//     padding: '3rem 1.5rem',
//     color: '#333',
//     fontFamily: "'Inter', sans-serif",
//     backgroundColor: '#f9fafb',
//   },
//   header: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '1rem',
//     marginBottom: '1.5rem',
//   },
//   headerIcon: {
//     fontSize: '2.5rem',
//     color: '#4169E1',
//   },
//   title: {
//     fontSize: '2.25rem',
//     fontWeight: 800,
//     color: '#4169E1',
//     margin: 0,
//   },
//   lastUpdated: {
//     fontSize: '0.875rem',
//     color: '#666',
//     marginTop: '0.25rem',
//   },
//   divider: {
//     border: 0,
//     height: '1px',
//     backgroundColor: '#ddd',
//     marginBottom: '2rem',
//   },
//   sections: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '1.75rem',
//   },
//   card: {
//     backgroundColor: '#ffffff',
//     padding: '1.5rem',
//     borderRadius: '12px',
//     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//   },
//   sectionTitle: {
//     fontSize: '1.25rem',
//     fontWeight: 700,
//     marginBottom: '0.75rem',
//     color: '#1a1a1a',
//   },
//   bulletList: {
//     paddingLeft: '1.2rem',
//     margin: 0,
//   },
//   bullet: {
//     marginBottom: '0.5rem',
//     lineHeight: '1.6',
//     fontSize: '0.95rem',
//   },
//   note: {
//     marginTop: '0.75rem',
//     fontStyle: 'italic',
//     color: '#666',
//   },
// };

// export default PrivacyPolicy;














import React, { CSSProperties, useEffect, useState } from 'react';

const PrivacyPolicy: React.FC = () => {


    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 940);

    useEffect(() => {
      const handleResize = () => {
      //   setIsMobile(window.innerWidth < 768);
      setIsMobile(window.innerWidth < 940);
      };
    
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);





//   const sections = [
//     {
//       title: '1. Introduction',
//       bullets: [
//         'Welcome to Instaship Logistics Private Limited ("Company," "we," "us," or "our"). This Privacy Policy explains how our company collects, uses, and protects your personal data when you use our services.',
//       ],
//     },
//     {
//       title: '2. Data Collection',
//       bullets: [
//         'Personal details: Name, mobile number, email, GST details',
//         'Payment information and transaction history',
//         'Location data for tracking and operational purposes',
//       ],
//     },
//     {
//       title: '3. Use of Data',
//       bullets: [
//         'Provide transportation services and manage bookings',
//         'Send order updates and promotional offers',
//         'Comply with legal and tax obligations',
//       ],
//     },
//     {
//       title: '4. Data Sharing',
//       bullets: [
//         'Share with transport partners for service fulfillment',
//         'Share mobile number with third-party service providers such as Cashfree (for payment processing) and Fast2SMS (for sending SMS notifications)',
//         'Share location data with Google Maps APIs for tracking and navigation',
//         'Never sell or rent user data to third parties',
//         'Share with government authorities when legally required',
//       ],
//     },
//     {
//       title: '5. Security',
//       bullets: [
//         'Implement strict security measures for data protection',
//         'Users responsible for securing login credentials',
//       ],
//     },
//     {
//       title: '6. Data Retention',
//       bullets: [
//         'Retain data as needed for operations and legal compliance',
//         'Data deletion requests subject to legal limitations',
//       ],
//     },
//     {
//       title: '7. Cookies and Tracking',
//       bullets: [
//         'Use cookies to enhance user experience',
//         'Manage preferences through browser settings',
//       ],
//     },
//     {
//       title: '8. Your Rights',
//       bullets: [
//         'Access, modify, or delete personal data',
//         'Submit data requests via support email',
//       ],
//     },
//     {
//       title: '9. Changes to Policy',
//       bullets: ['Notify users via email or app updates'],
//       note: 'By using our platform, you acknowledge reading and understanding this Privacy Policy.',
//     },
//   ];





const sections = [
    {
      title: '1. Introduction',
      bullets: [
        'Welcome to Instaship Logistics Private Limited ("Company," "we," "us," or "our"). This Privacy Policy outlines how we collect, use, share, and protect your personal information when you access or use our services.',
      ],
    },
    {
      title: '2. Data Collection',
      bullets: [
        'Personal information including name, mobile number, email address, and GST details',
        'Payment data and transaction history for billing and audit purposes',
        'Location information used for live tracking and service optimization',
      ],
    },
    {
      title: '3. Use of Data',
      bullets: [
        'To facilitate and manage transportation bookings and related services',
        'To send order updates, service notifications, and promotional communications',
        'To comply with applicable legal, tax, and regulatory requirements',
      ],
    },
    {
      title: '4. Data Sharing',
      bullets: [
        'Shared with transport partners to fulfill service bookings',
        'Mobile numbers may be shared with trusted third-party providers such as Cashfree (for secure payment processing) and Fast2SMS (for transactional SMS communication)',
        'Location data is shared with Google Maps APIs for route navigation, ETA calculation, and location-based services',
        'We do not sell or rent personal data to any third parties',
        'User data may be shared with government or regulatory authorities when legally required',
      ],
    },
    {
      title: '5. Security',
      bullets: [
        'We implement industry-standard security measures to safeguard your personal data from unauthorized access, misuse, or disclosure',
        'Users are responsible for maintaining the confidentiality of their login credentials and account information',
      ],
    },
    {
      title: '6. Data Retention',
      bullets: [
        'Personal data is retained only as long as necessary for operational, legal, or regulatory purposes',
        'Requests for data deletion will be reviewed and processed in compliance with applicable laws',
      ],
    },
    {
      title: '7. Cookies and Tracking',
      bullets: [
        'Cookies are used to enhance website functionality and personalize user experience',
        'Users can manage or disable cookies through their browser settings at any time',
      ],
    },
    {
      title: '8. Your Rights',
      bullets: [
        'You may request access to, correction of, or deletion of your personal data',
        'To exercise these rights, please contact our support team at the official email address provided on our platform',
      ],
    },
    {
      title: '9. Changes to Policy',
      bullets: [
        'We may update this Privacy Policy periodically and will notify users via email or app notifications when significant changes are made',
      ],
      note: 'By using our platform, you acknowledge that you have read, understood, and agreed to this Privacy Policy.',
    },
  ];
  
  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <span style={styles.headerIcon}>🔐</span>
        <div>
          <h1 
        //   style={styles.title}
          style={{ ...styles.title, fontSize: isMobile ? '1.75rem' : '2.25rem' }}>Privacy Policy</h1>
          <p style={{...styles.lastUpdated,fontSize: isMobile ? '0.75rem' : '0.875rem' }}>Last Updated: June 10, 2025</p>
        </div>
      </div>

      {/* Divider */}
      <hr style={styles.divider} />

      {/* Sections */}
      <div style={styles.sections}>
        {sections.map((section) => (
          <div key={section.title} style={styles.card}>
            <h2 style={{...styles.sectionTitle,fontSize: isMobile ? '1rem' : '1.25rem'}}>{section.title}</h2>
            <ul style={styles.bulletList}>
              {section.bullets.map((bullet, index) => (
                <li key={index}
                //  style={styles.bullet}
                 style={{
                    ...styles.bullet,
                    fontSize: isMobile ? '0.85rem' : '0.95rem',
                  }}>
                  {bullet}
                </li>
              ))}
            </ul>
            {section.note && <p style={{...styles.note,  fontSize: isMobile ? '0.85rem' : '0.95rem'}}>{section.note}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles: Record<string, CSSProperties> = {
  container: {
    maxWidth: '960px',
    margin: '0 auto',
    padding: '3rem 1.5rem',
    color: '#333',
    fontFamily: "'Inter', sans-serif",
    backgroundColor: '#f9fafb',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '1.5rem',
  },
  headerIcon: {
    fontSize: '2.5rem',
  },
  title: {
    fontSize: '2.25rem',
    fontWeight: 800,
    color: '#4169E1',
    margin: 0,
  },
  lastUpdated: {
    fontSize: '0.875rem',
    color: '#666',
    marginTop: '0.25rem',
  },
  divider: {
    border: 0,
    height: '1px',
    backgroundColor: '#ddd',
    marginBottom: '2rem',
  },
  sections: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.75rem',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '1.5rem',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  },
  sectionTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    marginBottom: '0.75rem',
    color: '#1a1a1a',
  },
  bulletList: {
    paddingLeft: '1.2rem',
    margin: 0,
  },
  bullet: {
    marginBottom: '0.5rem',
    lineHeight: '1.6',
    fontSize: '0.95rem',
  },
  note: {
    marginTop: '0.75rem',
    fontStyle: 'italic',
    color: '#666',
  },
};

export default PrivacyPolicy;
